/**
 * Utility to generate visitor fingerprint for analytics tracking
 */

export function getDeviceFingerprint(): {
  screenResolution: string;
  timezone: string;
  userAgent: string;
} {
  const screenResolution = `${window.screen.width}x${window.screen.height}`;
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const userAgent = navigator.userAgent;

  return {
    screenResolution,
    timezone,
    userAgent
  };
}

export function generateClientFingerprint(): string {
  const { screenResolution, timezone, userAgent } = getDeviceFingerprint();
  
  // Create a simple hash on the client side for quick lookups
  // Server will generate the actual secure hash
  const fingerprint = btoa(
    `${screenResolution}-${timezone}-${userAgent.slice(0, 50)}`
  ).slice(0, 16);
  
  return fingerprint;
}